import { render, staticRenderFns } from "./PolicyPrintAll.vue?vue&type=template&id=f2196358&scoped=true&"
import script from "./PolicyPrintAll.vue?vue&type=script&lang=js&"
export * from "./PolicyPrintAll.vue?vue&type=script&lang=js&"
import style0 from "./PolicyPrintAll.vue?vue&type=style&index=0&id=f2196358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2196358",
  null
  
)

export default component.exports